import React from 'react';
import { TourExtension as TourExtensionType } from '@model/tours';
import { SectionTitle } from '@components/common/section-title';
import { TourExtension } from './TourExtension';
import styled from '@emotion/styled';
import { TestId } from '@components/test-ids';
import { TripTypes } from '@model/common';
import { getImageUrl } from '@util/images';
import { breakpoints } from '@styles/breakpoints';
import { ThemeProps } from '@theme/base';

export interface TourExtensionGroupProps {
  extensions: Array<TourExtensionType>;
  heading: string;
  testId?: string;
  tripType: TripTypes;
}

const Container = styled.div({});

const CardWrapper = styled.div(({ theme }: ThemeProps) => ({
  marginBottom: theme.custom.spacing.xLarge,

  ['&:last-of-type']: {
    marginBottom: 0
  }
}));

export const ToursExtensionGroup = (props: TourExtensionGroupProps) => {
  const { heading, extensions, testId, tripType } = props;

  /* *** RENDERERS *** */
  const renderExtensionCards = () =>
    extensions.map((extension: TourExtensionType) => (
      <CardWrapper key={extension.name}>
        <TourExtension
          testId={TestId.extendToursGroup.card}
          title={extension.name}
          price={extension.price}
          length={extension.days}
          imageUrl={getImageUrl(extension.imageUrl, breakpoints.small)}
          path={extension.path}
          tripType={tripType}
        />
      </CardWrapper>
    ));

  return (
    <Container data-testid={testId || TestId.extendToursGroup.main}>
      <SectionTitle heading={heading} testId={TestId.extendToursGroup.heading} />
      {renderExtensionCards()}
    </Container>
  );
};

ToursExtensionGroup.defaultProps = {
  extensions: [],
  title: ''
};
